'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_GroceryItemSort(sortType, direction) {
  this.Sk = null;
  this.Sj = null;
  this.Sk = sortType;
  this.Sj = direction;
}
export { $c_Lmealorama_GroceryItemSort as $c_Lmealorama_GroceryItemSort };
$p = $c_Lmealorama_GroceryItemSort.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_GroceryItemSort;
/** @constructor */
function $h_Lmealorama_GroceryItemSort() {
}
export { $h_Lmealorama_GroceryItemSort as $h_Lmealorama_GroceryItemSort };
$h_Lmealorama_GroceryItemSort.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 1030717682, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_GroceryItemSort)) {
    var x = this.Sk;
    var x$2 = x$0.Sk;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.Sj;
      var x$4 = x$0.Sj;
      return ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 2;
});
$p.r = (function() {
  return "GroceryItemSort";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.Sk;
  }
  if ((n === 1)) {
    return this.Sj;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_GroceryItemSort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jy)));
}
export { $isArrayOf_Lmealorama_GroceryItemSort as $isArrayOf_Lmealorama_GroceryItemSort };
var $d_Lmealorama_GroceryItemSort = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_GroceryItemSort, "mealorama.GroceryItemSort", ({
  jy: 1,
  eK: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_GroceryItemSort as $d_Lmealorama_GroceryItemSort };
//# sourceMappingURL=mealorama.-Grocery-Item-Sort.js.map
